import * as actions from 'components/header/content-mask/actions';
import { handleActions } from 'redux-actions';

const initialState = {
  show: false,
};

export const contentMaskReducer = handleActions(
  {
    [actions.CONTENT_MASK_SHOW]: (prevState) => ({
      ...prevState,
      show: true,
    }),
    [actions.CONTENT_MASK_HIDE]: (prevState) => ({
      ...prevState,
      show: false,
    }),
  },
  initialState
);
